export default __webpack_public_path__ + "fonts/Beatrice-Semibold.woff";